// Query parameter used to highlight a specific announcement via the URL
export const ANNOUNCEMENT_PARAM = 'announcement';

// Card dimensions
export const CARD_HEIGHT = 96; // Fixed wrapper height in pixels (should match minH={24} = 96px in StackCardContent)

// Stacking visual constants
export const STACK_OFFSET_Y = 10; // Vertical offset between stacked cards
export const STACK_SCALE_DECREMENT = 0.025; // Scale reduction per card in stack
export const MAX_VISIBLE_STACKED = 3; // Max cards visible in collapsed stack

// Expanded state constants
export const EXPANDED_GAP = 8; // Gap between cards when expanded

// Animation timings
export const TRANSITION_DURATION = '300ms';
export const TRANSITION_EASING = 'ease';

// Accessibility - respects user's reduced motion preference
export const REDUCED_MOTION_SX = {
	'@media (prefers-reduced-motion: reduce)': {
		transition: 'none',
	},
};
